export const common = {
  // Navigation
  'nav.features': 'Funkcje',
  'nav.howItWorks': 'Jak to działa',
  'nav.pricing': 'Cennik',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'O nas',
  'nav.getStarted': 'Rozpocznij',

  // About Us Section
  'aboutUs.badge': 'O nas',
  'aboutUs.title': 'O nas',
  'aboutUs.line1': 'Pomysły są tanie.',
  'aboutUs.line2': 'Kapitał nie. Czas tym bardziej nie.',
  'aboutUs.paragraph1': 'IdeaOracle.ai zostało założone, ponieważ większość pomysłów biznesowych nie upada z powodu braku odwagi – ale z powodu braku uczciwości. Za dużo potwierdzenia. Za mało rzeczywistości.',
  'aboutUs.belief1a': 'Nie wierzymy w szum medialny.',
  'aboutUs.belief1b': 'Wierzymy w logikę rynku.',
  'aboutUs.belief2a': 'Nie wierzymy w motywację.',
  'aboutUs.belief2b': 'Wierzymy w popyt, konkurencję i różnicowanie.',
  'aboutUs.mission1': 'Naszym zadaniem nie jest sprawianie, by pomysły wyglądały dobrze.',
  'aboutUs.mission2': 'Naszym zadaniem jest ujawnianie ich wykonalności.',
  'aboutUs.analysis': 'IdeaOracle.ai analizuje nisze biznesowe pod kątem strukturalnej mechaniki rynku, realistycznego popytu, intensywności konkurencji i wykonalności. Nie emocjonalnie. Nie optymistycznie. Ale trzeźwo.',
  'aboutUs.failure1': 'Większość pomysłów upada.',
  'aboutUs.failure2': 'Nie dlatego, że założyciele są niezdolni –',
  'aboutUs.failure3': 'ale dlatego, że nikt wcześniej nie był wystarczająco jasny.',
  'aboutUs.clarity': 'Istniejemy, aby dostarczyć tę jasność.',
  'aboutUs.value1': 'Niewygodnie.',
  'aboutUs.value2': 'Bezpośrednio.',
  'aboutUs.value3': 'Konsekwentnie.',
  'aboutUs.confirm': 'Jeśli pomysł ma substancję, potwierdzamy to.',
  'aboutUs.deny': 'Jeśli nie, również to mówimy.',
  'aboutUs.noApplause': 'Bez oklasków.',
  'aboutUs.noSugarcoating': 'Bez upiększania.',
  'aboutUs.noTheater': 'Bez teatru.',

  // Hero Section
  'hero.badge': 'AI decyzyjna dla nisz biznesowych',
  'hero.title1': 'Pomysły są tanie.',
  'hero.title2': 'Złe decyzje nie są.',
  'hero.subtitle': 'AI, które ocenia twoją niszę biznesową',
  'hero.subtitleLine2': 'zanim zainwestujesz.',
  'hero.cta': 'Sprawdź pomysł',
  'hero.ctaSecondary': 'Jak to działa',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Kredytów na zapytanie',
  'hero.stat2Value': 'Od 7',
  'hero.stat2Label': 'Poziomy oceny',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Uczciwe i prywatne',

  // Features Section
  'features.title1': 'Potężne funkcje dla',
  'features.title2': 'nowoczesnych',
  'features.title3': 'firm',
  'features.honestVerdict.title': 'Uczciwa ocena, nie hype',
  'features.honestVerdict.description': 'Jasne werdykty dobry/średni/słaby oparte na realnych danych rynkowych i analizie konkurencji. Żadnych ocen 9/10 mających pochlebiać każdemu pomysłowi.',
  'features.fullJourney.title': 'Od testu pomysłu do Builder Report',
  'features.fullJourney.description': 'Sprawdź w czacie, pogłęb analizę rynku, wyeksportuj Builder Report na 25–75 stron z personami, finansami, go-to-market i pitch deckiem.',
  'features.multilingual.title': '21 języków, lokalne dane rynkowe',
  'features.multilingual.description': 'Od szwajcarskiego MŚP po solo-foundera w São Paulo — AI odpowiada w twoim języku, ze źródłami z twojego rynku.',

  // How It Works
  'howItWorks.title': 'Jak to działa',
  'howItWorks.subtitle': 'Cztery kroki do jasności w sprawie twojej niszy biznesowej.',
  'howItWorks.step1Title': 'Wybierz plan',
  'howItWorks.step1Desc': 'Starter, Pro lub Builder – w zależności od głębokości twojej weryfikacji.',
  'howItWorks.step2Title': 'Zapytaj AI',
  'howItWorks.step2Desc': 'Zadaj swoje pytania o niszę. Każde zapytanie kosztuje 30 kredytów.',
  'howItWorks.step3Title': 'Otrzymaj szczery werdykt',
  'howItWorks.step3Desc': 'AI ocenia: Dobry, Średni lub Zły. Bez owijania w bawełnę.',
  'howItWorks.step4Title': 'Podejmij decyzję',
  'howItWorks.step4Desc': 'Teraz wiesz, czy warto iść dalej.',

  // Pricing
  'pricing.title': 'Cennik',
  'pricing.subtitle': 'Wybierz plan odpowiadający głębokości twojej weryfikacji.',
  'pricing.yearlyDiscount': 'Subskrypcja roczna:',
  'pricing.yearlyDiscountValue': '-20% zniżki',
  'pricing.perMonth': 'miesięcznie',
  'pricing.selectPlan': 'Wybierz plan',
  'pricing.mostPopular': 'Najpopularniejszy',
  'pricing.footer': 'Wszystkie ceny w CHF. Kredyty są odliczane tylko za udane odpowiedzi AI.',
  
  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.description': 'Do początkowych testów rzeczywistości.',
  'pricing.starter.credits': '2 500 kredytów',
  'pricing.starter.feature1': 'Generowanie pomysłu na niszę',
  'pricing.starter.feature2': 'Doprecyzowanie niszy',
  'pricing.starter.feature3': 'Sprawdzenie rzeczywistości rynkowej',
  'pricing.starter.feature4': 'Ocena konkurencji',
  'pricing.starter.feature5': 'Ocena czasu',
  'pricing.starter.feature6': 'Szczery werdykt',
  'pricing.starter.feature7': 'Prywatne sesje',
  'pricing.starter.feature8': 'Historia i eksport',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.description': 'Do głębszej weryfikacji.',
  'pricing.pro.credits': '5 000 kredytów',
  'pricing.pro.feature1': 'Wszystkie funkcje Starter',
  'pricing.pro.feature2': 'Więcej kredytów na intensywną weryfikację',
  'pricing.pro.feature3': 'Sugestie ulepszeń',
  'pricing.pro.feature4': 'Alternatywne nisze',
  'pricing.pro.feature5': 'Szczegółowa analiza rynku',
  'pricing.pro.feature6': 'Wsparcie priorytetowe',
  'pricing.pro.feature7': 'Zaawansowane filtry',
  'pricing.pro.feature8': 'Ulubione sesje',

  // Builder Plan
  'pricing.builder.name': 'Builder',
  'pricing.builder.description': 'Pomysł → Brief dla programistów.',
  'pricing.builder.credits': 'Nieograniczone kredyty',
  'pricing.builder.feature1': 'Wszystkie funkcje Pro',
  'pricing.builder.feature2': 'Nieograniczone zapytania AI',
  'pricing.builder.feature3': 'Tryb Builder: Brief dla programistów',
  'pricing.builder.feature4': 'Ustrukturyzowany przegląd projektu',
  'pricing.builder.feature5': 'Przepływy użytkownika i główne funkcje',
  'pricing.builder.feature6': 'Notatki techniczne',
  'pricing.builder.feature7': 'Określenie nie-celów',
  'pricing.builder.feature8': 'Limit fair use',
  'pricing.builder.limitNote': 'Limit fair use',
  'pricing.monthlyReset': 'Miesięczny reset',

  // Modal
  'pricing.modal.selected': 'wybrany',
  'pricing.modal.comingSoon': 'Rejestracja i przetwarzanie płatności będą wkrótce dostępne.',
  'pricing.modal.patience': 'Pracujemy nad zapewnieniem bezpiecznego i płynnego doświadczenia. Prosimy o cierpliwość.',
  'pricing.modal.understood': 'Rozumiem',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Odpowiedzi szczere i krytyczne.',
  'faq.q1': 'Co konkretnie robi IdeaOracle.ai?',
  'faq.a1': 'IdeaOracle.ai ocenia pomysły biznesowe i nisze pod kątem logiki rynku, realnego popytu, konkurencji, różnicowania i wykonalności.\nJeśli jest substancja, pokazujemy, jak można ją strategicznie wyostrzyć.\nJeśli nie, mówimy to.',
  'faq.q2': 'Czy generujecie też pomysły?',
  'faq.a2': 'Tak.\nAle nie na ślepo.\nRozwijamy podejścia oparte na logice rynku – nie na motywacji czy modzie.',
  'faq.q3': 'Czy optymalizujecie modele biznesowe?',
  'faq.a3': 'Tak – jeśli istnieje potencjał.\nNie polerujemy iluzji.\nSprawiamy, że wykonalne koncepcje stają się bardziej odporne.',
  'faq.q4': 'Co was odróżnia od innych narzędzi AI?',
  'faq.a4': 'Inne narzędzia dostarczają inspirację.\nMy dostarczamy ocenę.\nNacisk kładziemy na realizm, nie na entuzjazm.',
  'faq.q5': 'Czy to gwarancja sukcesu?',
  'faq.a5': 'Nie.\nRedukujemy złe decyzje – nie eliminujemy ryzyka.',
  'faq.q6': 'Dla kogo jest IdeaOracle.ai?',
  'faq.a6': 'Założyciele przed startem\nPrzedsiębiorcy przed ekspansją\nSide-builderzy przed inwestycją czasu\nInwestorzy przed oceną\n\nW skrócie: Dla ludzi, którzy chcą jasności przed kapitałem.',
  'faq.q7': 'A jeśli szukam tylko potwierdzenia?',
  'faq.a7': 'Wtedy IdeaOracle.ai nie jest odpowiednim narzędziem.',
  'faq.q8': 'Jak szczera jest analiza?',
  'faq.a8': 'Tak szczera, jak pozwalają na to dane i mechanika rynku.\nBez euforii. Bez taryfy ulgowej.',
  'faq.q9': 'Czy zastępujecie badania rynku?',
  'faq.a9': 'Nie.\nJesteśmy strategiczną oceną wstępną – nie pełnym badaniem rynku.',
  'faq.q10': 'Dlaczego tak bezkompromisowo?',
  'faq.a10': 'Ponieważ porażka jest droga.\nUczciwość nie.',

  // Footer
  'footer.description': 'Ta platforma nie pomaga ci czuć się dobrze – ale podejmować właściwe decyzje.',
  'footer.product': 'Produkt',
  'footer.aiAssistant': 'Asystent AI',
  'footer.howItWorks': 'Jak to działa',
  'footer.pricing': 'Cennik',
  'footer.faq': 'FAQ',
  'footer.legal': 'Prawne',
  'footer.privacy': 'Prywatność',
  'footer.terms': 'Warunki',
  'footer.imprint': 'Stopka',
  'footer.support': 'Wsparcie',
  'footer.contact': 'Kontakt',
  'footer.documentation': 'Dokumentacja',
  'footer.copyright': '© 2025 IdeaOracle.ai. Wszelkie prawa zastrzeżone.',

  // AI Assistant
  'aiAssistant.title': 'Asystent AI nisz',
  'aiAssistant.subtitle': 'Pytania o nisze',
  'aiAssistant.welcomeMessage': 'Cześć! Opisz swój pomysł lub zapytaj mnie o niszę. Dam ci jasną i szczerą ocenę.',
  'aiAssistant.demoResponse': 'To jest demo. Aby uzyskać prawdziwe oceny AI, zarejestruj się i wybierz plan.',
  'aiAssistant.placeholder': 'Opisz swój pomysł...',

  // Header & Sidebar
  'dashboard.header.title': 'Panel',
  'dashboard.sidebar.overview': 'Przegląd',
  'dashboard.sidebar.newAnalysis': 'Asystent AI',
  'dashboard.sidebar.history': 'Historia',
  'dashboard.sidebar.credits': 'Kredyty',
  'dashboard.sidebar.settings': 'Ustawienia',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Witaj ponownie, {{name}}',
  'dashboard.overview.subtitle': 'Oto szybki przegląd twojej aktywności',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Pozostałe kredyty',
  'dashboard.stats.totalAnalyses': 'Łączne analizy',
  'dashboard.stats.goodRatings': 'Pozytywne oceny',
  'dashboard.stats.nextReset': 'Następny reset za',
  'dashboard.stats.days': 'dni',

  // Quick Actions
  'dashboard.quickActions.title': 'Szybkie akcje',
  'dashboard.quickActions.checkNewIdea': 'Sprawdź pomysł',
  'dashboard.quickActions.checkNewIdeaDesc': 'Przeanalizuj istniejący pomysł biznesowy',
  'dashboard.quickActions.generateIdea': 'Wygeneruj pomysł',
  'dashboard.quickActions.generateIdeaDesc': 'Znajdź nową dochodową niszę',
  'dashboard.quickActions.builderBriefing': 'Brief Builder',
  'dashboard.quickActions.builderBriefingDesc': 'Przekształć pomysł w brief gotowy dla programistów',
  'dashboard.quickActions.premiumOnly': 'Tylko Builder',

  // Chat Header
  'chat.title': 'Asystent AI nisz',
  'chat.subtitle': 'Zadawaj pytania o nisze. Oceniam krytycznie i szczerze.',
  'chat.creditsLabel': 'Kredyty',

  // Chat Welcome
  'chat.welcomeTitle': 'Witaj w Asysteńcie AI nisz',
  'chat.welcomeDesc': 'Opisz swój pomysł lub zapytaj o niszę. Ocenię szczerze: Dobry, Średni lub Zły.',
  'chat.aiWelcome': 'Cześć! Opisz swój pomysł lub zapytaj mnie o niszę. Dam ci jasną i szczerą ocenę.',

  // Chat Suggestions
  'chat.suggestion1': 'Znajdź mi dochodową niszę.',
  'chat.suggestion2': 'Mam pomysł – oceń go szczerze.',
  'chat.suggestion3': 'Które nisze mają teraz potencjał?',
  'chat.suggestion4': 'Doprecyzuj tę niszę i uczyń ją bardziej konkretną.',

  // Chat Actions
  'chat.newConversation': 'Nowa rozmowa',
  'chat.today': 'Dzisiaj',
  'chat.yesterday': 'Wczoraj',
  'chat.thisWeek': 'W tym tygodniu',
  'chat.thisMonth': 'W tym miesiącu',
  'chat.older': 'Starsze',
  'chat.messages': 'wiadomości',
  'chat.renameConversation': 'Zmień nazwę',
  'chat.deleteConversation': 'Usuń',
  'chat.cancel': 'Anuluj',
  'chat.rename': 'Zmień nazwę',
  'chat.delete': 'Usuń',
  'chat.favorite': 'Dodaj do ulubionych',
  'chat.unfavorite': 'Usuń z ulubionych',
  'chat.searchSessions': 'Szukaj rozmów...',
  'chat.noResults': 'Nie znaleziono wyników',
  'chat.noSessions': 'Jeszcze brak rozmów',
  'chat.enterNewName': 'Wprowadź nową nazwę...',
  'chat.deleteConfirmMessage': 'Czy na pewno chcesz usunąć tę rozmowę? Tej akcji nie można cofnąć.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Wpisz swoje pytanie… (kosztuje 30 kredytów)',
  'chat.send': 'Wyślij',
  'chat.voice': 'Mów',
  'chat.listeningPlaceholder': 'Słucham... Mów teraz.',
  'chat.stopListening': 'Zatrzymaj nagrywanie',
  'chat.recording': 'Nagrywanie...',
  'chat.speechNotSupported': 'Rozpoznawanie mowy nie jest obsługiwane przez twoją przeglądarkę.',
  'chat.microphonePermissionDenied': 'Odmówiono dostępu do mikrofonu. Zezwól na dostęp w ustawieniach przeglądarki.',
  'chat.errorNotEnoughCredits': 'Za mało kredytów. Ulepsz swój plan lub poczekaj na następny reset.',
  'chat.errorAiFailed': 'Odpowiedź AI nie powiodła się. Nie odliczono kredytów.',
  'chat.errorRateLimit': 'Zbyt wiele zapytań. Poczekaj chwilę.',

  // Ratings
  'rating.good': 'Dobry',
  'rating.medium': 'Średni',
  'rating.bad': 'Zły',

  // Auth Page
  'auth.branding.headline1': 'Nie każdy pomysł jest dobry.',
  'auth.branding.headline2': 'Szczerze powiemy, który jest.',
  'auth.branding.subtitle': 'AI decyzyjna dla nisz biznesowych. Jasno. Krytycznie. Bez owijania w bawełnę.',
  'auth.benefits.privacy.title': '100% Prywatne',
  'auth.benefits.privacy.desc': 'Twoje pomysły pozostają całkowicie prywatne i bezpieczne.',
  'auth.benefits.honest.title': 'Uczciwa AI',
  'auth.benefits.honest.desc': 'Bez owijania w bawełnę – tylko jasna, krytyczna informacja zwrotna.',
  'auth.benefits.fast.title': 'Szybkie Wyniki',
  'auth.benefits.fast.desc': 'Uzyskaj jasność co do swojej niszy w kilka minut.',
  'auth.trust.users': 'Aktywni Użytkownicy',
  'auth.trust.ideas': 'Przeanalizowane Pomysły',
  'auth.trust.rating': 'Ocena',
  'auth.login.title': 'Zaloguj się',
  'auth.login.headline': 'Witaj ponownie',
  'auth.login.subtitle': 'Zaloguj się, aby kontynuować swoją podróż.',
  'auth.login.forgotPassword': 'Zapomniałeś hasła?',
  'auth.login.submit': 'Zaloguj się',
  'auth.login.noAccount': 'Nie masz konta?',
  'auth.login.signUp': 'Zarejestruj się',
  'auth.register.title': 'Zarejestruj się',
  'auth.register.headline': 'Utwórz swoje konto',
  'auth.register.subtitle': 'Zacznij analizować swoje pomysły biznesowe już dziś.',
  'auth.register.submit': 'Utwórz Konto',
  'auth.register.hasAccount': 'Masz już konto?',
  'auth.register.signIn': 'Zaloguj się',
  'auth.fields.name': 'Pełne Imię',
  'auth.fields.email': 'Adres E-mail',
  'auth.fields.password': 'Hasło',
  'auth.fields.confirmPassword': 'Potwierdź Hasło',
  'auth.fields.selectPlan': 'Wybierz swój plan',
  'auth.placeholders.name': 'Wprowadź swoje imię',
  'auth.placeholders.email': 'Wprowadź swój e-mail',
  'auth.placeholders.password': 'Wprowadź swoje hasło',
  'auth.placeholders.confirmPassword': 'Potwierdź swoje hasło',
  'auth.terms.accept': 'Akceptuję',
  'auth.terms.terms': 'Regulamin',
  'auth.privacy.accept': 'Akceptuję',
  'auth.privacy.policy': 'Politykę Prywatności',
  'auth.errors.nameRequired': 'Imię jest wymagane',
  'auth.errors.emailRequired': 'E-mail jest wymagany',
  'auth.errors.emailInvalid': 'Wprowadź prawidłowy e-mail',
  'auth.errors.passwordRequired': 'Hasło jest wymagane',
  'auth.errors.passwordLength': 'Hasło musi mieć co najmniej 8 znaków',
  'auth.errors.passwordMismatch': 'Hasła nie są zgodne',
  'auth.loading': 'Proszę czekać...',
  'auth.or': 'lub kontynuuj z',
  'auth.social.google': 'Kontynuuj z Google',
  'auth.social.apple': 'Kontynuuj z Apple',

  // Trial Plan
  'pricing.trial.name': 'Trial',
  'pricing.trial.description': '3-dniowy bezpłatny dostęp',
  'pricing.trial.credits': '250 kredytów',
  'pricing.trial.free': 'Gratis',
  'pricing.trial.duration': 'Bez opłat przez 3 dni',
  'pricing.trial.cta': 'Rozpocznij bezpłatny okres próbny',
  'pricing.trial.feature1': '250 kredytów na poznanie AI',
  'pricing.trial.feature2': 'Pełny dostęp przez 3 dni',
  'pricing.trial.feature3': 'Bez karty kredytowej',
  'pricing.trial.feature4': 'Anuluj w dowolnym momencie',

  // Gold Package
  'pricing.gold.name': 'Gold',
  'pricing.gold.description': '10 000 kredytów + 25-stronicowy raport Builder',
  'pricing.gold.credits': '10 000 kredytów',
  'pricing.gold.feature1': '10 000 kredytów',
  'pricing.gold.feature2': '25-stronicowy raport Builder',
  'pricing.gold.feature3': 'Wszystkie funkcje Starter i Pro',
  'pricing.gold.feature4': 'Analiza rynku i podsumowanie',
  'pricing.gold.feature5': 'Szanse, ryzyka, rekomendacje',
  'pricing.gold.feature6': 'Pobierz PDF',
  'pricing.gold.feature7': 'Wsparcie',

  // Platinum Package
  'pricing.platinum.name': 'Platinum',
  'pricing.platinum.description': '15 000 kredytów + 100-stronicowy raport Builder',
  'pricing.platinum.credits': '15 000 kredytów',
  'pricing.platinum.feature1': '15 000 kredytów',
  'pricing.platinum.feature2': '100-stronicowy raport Builder',
  'pricing.platinum.feature3': 'Wszystkie funkcje Gold',
  'pricing.platinum.feature4': 'Tryb Builder: briefingi dla deweloperów',
  'pricing.platinum.feature5': 'Ustrukturyzowane podsumowanie',
  'pricing.platinum.feature6': 'Zaawansowana analiza rynku',
  'pricing.platinum.feature7': 'Wsparcie',

  // Pricing UI
  'pricing.monthly': 'Miesięcznie',
  'pricing.yearly': 'Rocznie',
  'pricing.savings': 'oszczędności',
  'pricing.billedYearly': 'Rozliczenie roczne',

  // Hero trial CTA
  'hero.trialTitle': 'Rozpocznij bezpłatny okres próbny',
  'hero.creditsLabel': 'Kredyty',
  'hero.trialTagline': 'Wypróbuj naszego asystenta AI bezpłatnie przez 3 dni',
  'hero.trialCta': 'Zarejestruj się i otrzymaj 250 kredytów',
  'hero.trialNoCard': 'Bez karty kredytowej. Bez zobowiązań.',

  // Admin
  'admin.dashboard.tabs.plans': 'Plany',

  // Credit top-up
  'dashboard.credits.topup.button': 'Doładuj kredyty',
  'dashboard.credits.topup.buttonTitle': 'Kup więcej kredytów bez zmiany planu',
  'dashboard.credits.topup.title': 'Doładuj kredyty',
  'dashboard.credits.topup.subtitle': 'CHF 0,15 za kredyt — bez zmiany planu',
  'dashboard.credits.topup.quickAmounts': 'Szybki wybór',
  'dashboard.credits.topup.custom': 'Niestandardowa',
  'dashboard.credits.topup.totalLabel': 'Razem',
  'dashboard.credits.topup.creditsLabel': 'Kredyty',
  'dashboard.credits.topup.confirm': 'Kup teraz',
  'footer.disclaimer': 'Zastrzeżenie',
  'legal.backToHome': 'Powrót do strony głównej',
  'legal.lastUpdated': 'Ostatnia aktualizacja',
  'legal.allRightsReserved': 'Wszelkie prawa zastrzeżone.',
  'legal.authoritativeNotice': 'Zlokalizowana wersja w twoim języku nie jest jeszcze dostępna. Poniżej znajduje się oryginalny, wiążący tekst w języku angielskim.',
  'legal.translationNotice': 'Jest to tłumaczenie pomocnicze. Wersja angielska jest prawnie wiążącym oryginałem.',
};

export default common;
